<svg width="15" height="25" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
  <line y1="13.6421" x2="28.2843" y2="13.6421" stroke="black" />
</svg>
